import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { ToroNotification } from '../models/toro-notification.model';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class NotificationService extends ApiService
{

    constructor(protected http: HttpClient,
                protected localCacheManager: LocalCacheManager,
                private apiUrlService: ApiUrlService)
    {
        super(http, localCacheManager);
    }

    public pollForNotifications(accountId: number, lastNotificationId?: string): Observable<ToroNotification[]>
    {
        let url = this.apiUrlService.getNotificationUrl(accountId);
        if (lastNotificationId)
        {
            url += `?lastNotificationId=${lastNotificationId}`;
        }

        return this.apiRequest<ToroNotification[]>(url, this.HttpMethod.Get)
            .pipe(
                map(notifications =>
                {
                    const toroNotifications: ToroNotification[] = [];
                    if (notifications.length)
                    {
                        notifications.forEach(notification =>
                        {
                            toroNotifications.push(new ToroNotification(notification));
                        });
                    }

                    return toroNotifications;
                })
            );
    }

}
